import { getRuntimeConfigOrDefault } from '../utils/runtime-config';

// OAuth configuration with runtime support
export const oauthConfig = {
  google: {
    // Use runtime config first, then process.env, then default
    clientId: getRuntimeConfigOrDefault('REACT_APP_GOOGLE_CLIENT_ID', '1234567890-abcdefghijklmnopqrstuvwxyz123456.apps.googleusercontent.com'),
    redirectUri: getRuntimeConfigOrDefault('REACT_APP_GOOGLE_REDIRECT_URI', 'http://localhost:3000/auth/google/callback'),
    scope: 'openid profile email'
  },
  linkedin: {
    clientId: getRuntimeConfigOrDefault('REACT_APP_LINKEDIN_CLIENT_ID', 'YOUR_LINKEDIN_CLIENT_ID'),
    clientSecret: getRuntimeConfigOrDefault('REACT_APP_LINKEDIN_CLIENT_SECRET', ''),
    redirectUri: getRuntimeConfigOrDefault('REACT_APP_LINKEDIN_REDIRECT_URI', 'http://localhost:3000/auth/linkedin/callback'),
    scope: 'openid profile email',
    state: 'random_string_here' // Should be generated dynamically
  },
  apple: {
    clientId: getRuntimeConfigOrDefault('REACT_APP_APPLE_CLIENT_ID', 'YOUR_APPLE_CLIENT_ID'),
    redirectUri: getRuntimeConfigOrDefault('REACT_APP_APPLE_REDIRECT_URI', 'http://localhost:3000/auth/apple/callback'),
    scope: 'name email'
  },
  api: {
    baseUrl: getRuntimeConfigOrDefault('REACT_APP_API_URL', 'http://localhost:3001/api')
  }
};

// LinkedIn OAuth URLs
export const linkedInAuthUrl = () => {
  const params = new URLSearchParams({
    response_type: 'code',
    client_id: oauthConfig.linkedin.clientId,
    redirect_uri: oauthConfig.linkedin.redirectUri,
    state: oauthConfig.linkedin.state,
    scope: oauthConfig.linkedin.scope
  });
  
  return `https://www.linkedin.com/oauth/v2/authorization?${params.toString()}`;
};

// Apple OAuth URL
export const appleAuthUrl = () => {
  const params = new URLSearchParams({
    response_type: 'code',
    response_mode: 'form_post',
    client_id: oauthConfig.apple.clientId,
    redirect_uri: oauthConfig.apple.redirectUri,
    scope: oauthConfig.apple.scope
  });
  
  return `https://appleid.apple.com/auth/authorize?${params.toString()}`;
};